export const MuiTextField = { defaultProps: { size: "small" as const } };
export const MuiFormControl = { defaultProps: { size: "small" as const } };
export const MuiAutocomplete = { defaultProps: { size: "small" as const } };
export const MuiCheckbox = { defaultProps: { size: "small" as const } };
export const MuiRadio = { defaultProps: { size: "small" as const } };
export const MuiSwitch = { defaultProps: { size: "small" as const } };
